import {
  IFetchFormSubmissionsAction,
  IFetchFormSubmissionsSuccessPayload,
  IFormFieldSubmission,
  IFetchFormSubmissionsPayload,
  IFetchFormSubmissionsDataToExportAction,
  IFetchFormSubmissionsDataToExportPayload,
  IFetchFormSubmissionSettingsSuccessActionPayload,
  IFetchFormSubmissionSettingsAction,
  IFetchFormSubmissionSettingsFailureActionPayload,
  IFetchMySubmissionsPayload,
  IFieldSubmissionMap,
  IFormSubmissionPagination,
  IFetchSubmissionBySubmissionId,
  IAddFormSubmissionPayload,
  IFormSubmission,
  IUniversalStorageData,
  IFetchPinCode,
  IFetchPicodePayload,
  IRespondedBySubmissionMap,
  ICheckDuplicateSubmissionFieldSuccessResponsePayload,
  IAddFormBulkSubmissionPayload,
  ILinkedFieldPayload,
  ILinkedFieldOptions,
  ILookupOptionsState,
  ITableSubmissionMap,
  IOtpRequest,
} from "@common/redux/formSubmission/interface";

const actionTypePrefix = "FORM_SUBMISSION/";

export const formSubmissionActions = {
  ADD_NEW_FIELD: `${actionTypePrefix}ADD_NEW_FIELD`,
  ADD_DATAGRID_SUBMISSION_ACTIONS: `${actionTypePrefix}ADD_DATAGRID_SUBMISSION_ACTIONS`,
  ADD_DATAGRID_COMPOSITE_KEYS_VALIDATION: `${actionTypePrefix}ADD_DATAGRID_COMPOSITE_KEYS_VALIDATION`,
  SET_IS_SAME_PAGE: `${actionTypePrefix}SET_IS_SAME_PAGE`,
  ADD_VISITED_PAGE: `${actionTypePrefix}ADD_VISITED_PAGE`,
  RESET_VISITED_PAGES: `${actionTypePrefix}RESET_VISITED_PAGES`, 
  UPDATE_FIELD_DATA: `${actionTypePrefix}UPDATE_FIELD_DATA`,
  UPDATE_FIELD_DATA_SUCCESS: `${actionTypePrefix}UPDATE_FIELD_DATA_SUCCESS`,

  BULK_UPDATE_FORM_DATA: `${actionTypePrefix}BULK_UPDATE_FORM_DATA`,
  BULK_UPDATE_FORM_DATA_SUCCESS: `${actionTypePrefix}BULK_UPDATE_FORM_DATA_SUCCESS`,

  BULK_UPDATE_FORM_DATA_FOR_VALIDATION: `${actionTypePrefix}BULK_UPDATE_FORM_DATA_FOR_VALIDATION`,

  SET_UNIVERSAL_STORAGE_UNIT: `${actionTypePrefix}SET_UNIVERSAL_STORAGE_UNIT`,

  RESET_SUBMISSION_FORM: `${actionTypePrefix}RESET_SUBMISSION_FORM`,

  SET_ACTIVE_FORM_SUBMISSION: `${actionTypePrefix}SET_ACTIVE_FORM_SUBMISSION`,
  SET_ACTIVE_FORM_SUBMISSION_SUCCESS: `${actionTypePrefix}SET_ACTIVE_FORM_SUBMISSION_SUCCESS`,

  RESET_ACTIVE_FORM_SUBMISSION: `${actionTypePrefix}RESET_ACTIVE_FORM_SUBMISSION`,
  //Saga
  FETCH_FORM_SUBMISSIONS: `${actionTypePrefix}FETCH_FORM_SUBMISSIONS`,

  FETCH_FORM_SUBMISSIONS_SUCCESS: `${actionTypePrefix}FETCH_FORM_SUBMISSIONS_SUCCESS`,

  FETCH_FORM_SUBMISSIONS_ERROR: `${actionTypePrefix}FETCH_FORM_SUBMISSIONS_ERROR`,

  FETCH_PINCODE_DATA: `${actionTypePrefix}FETCH_PINCODE_DATA`,

  DELETE_FORM_SUBMISSION: `${actionTypePrefix}DELETE_FORM_SUBMISSION`,

  DELETE_FORM_SUBMISSION_SUCCESS: `${actionTypePrefix}DELETE_FORM_SUBMISSION_SUCCESS`,

  DELETE_FORM_SUBMISSION_ERROR: `${actionTypePrefix}DELETE_FORM_SUBMISSION_ERROR`,

  DELETE_DATAGRID_FORM_SUBMISSION: `${actionTypePrefix}DELETE_DATAGRID_FORM_SUBMISSION`,

  DELETE_DATAGRID_SUBMISSION_SUCCESS: `${actionTypePrefix}DELETE_DATAGRID_SUBMISSION_SUCCESS`,

  DELETE_DATAGRID_SUBMISSION_ERROR: `${actionTypePrefix}DELETE_DATAGRID_SUBMISSION_ERROR`,

  UPDATE_FORM_SUBMISSION: `${actionTypePrefix}UPDATE_FORM_SUBMISSION`,

  UPDATE_FORM_SUBMISSION_SUCCESS: `${actionTypePrefix}UPDATE_FORM_SUBMISSION_SUCCESS`,

  UPDATE_FORM_SUBMISSION_ERROR: `${actionTypePrefix}UPDATE_FORM_SUBMISSION_ERROR`,

  ADD_FORM_SUBMISSION: `${actionTypePrefix}ADD_FORM_SUBMISSION`,
  SEND_OR_VALIDATE_OTP: `${actionTypePrefix}SEND_OR_VALIDATE_OTP`,

  ADD_FORM_SUBMISSION_SUCCESS: `${actionTypePrefix}ADD_FORM_SUBMISSION_SUCCESS`,
  SEND_OR_VALIDATE_OTP_SUCCESS: `${actionTypePrefix}SEND_OR_VALIDATE_OTP_SUCCESS`,

  ADD_FORM_SUBMISSION_ERROR: `${actionTypePrefix}ADD_FORM_SUBMISSION_ERROR`,
  SEND_OR_VALIDATE_OTP_ERROR: `${actionTypePrefix}SEND_OR_VALIDATE_OTP_ERROR`,

  ADD_FORM_BULK_SUBMISSION: `${actionTypePrefix}ADD_FORM_BULK_SUBMISSION`,

  ADD_FORM_BULK_SUBMISSION_SUCCESS: `${actionTypePrefix}ADD_FORM_BULK_SUBMISSION_SUCCESS`,

  ADD_FORM_BULK_SUBMISSION_ERROR: `${actionTypePrefix}ADD_FORM_BULK_SUBMISSION_ERROR`,

  UPDATE_FORM_BULK_SUBMISSION: `${actionTypePrefix}UPDATE_FORM_BULK_SUBMISSION`,

  UPDATE_FORM_BULK_SUBMISSION_SUCCESS: `${actionTypePrefix}UPDATE_FORM_BULK_SUBMISSION_SUCCESS`,

  UPDATE_FORM_BULK_SUBMISSION_ERROR: `${actionTypePrefix}UPDATE_FORM_BULK_SUBMISSION_ERROR`,

  FETCH_EXISTING_FORM_SUBMISSION_DATA: `${actionTypePrefix}FETCH_EXISTING_FORM_SUBMISSION_DATA`,

  FORM_SUBMISSIONS_EXPORT: `${actionTypePrefix}FORM_SUBMISSIONS_EXPORT`,

  FETCH_FORM_SUBMISSION_SETTINGS: `${actionTypePrefix}FETCH_FORM_SUBMISSION_SETTINGS`,
  FETCH_FORM_SUBMISSION_SETTINGS_SUCCESS: `${actionTypePrefix}FETCH_FORM_SUBMISSION_SETTINGS_SUCCESS`,
  FETCH_FORM_SUBMISSION_SETTINGS_FAILURE: `${actionTypePrefix}FETCH_FORM_SUBMISSION_SETTINGS_FAILURE`,

  FETCH_MY_SUBMISSIONS: `${actionTypePrefix}FETCH_MY_SUBMISSIONS`,
  FETCH_MY_SUBMISSIONS_SUCCESS: `${actionTypePrefix}FETCH_MY_SUBMISSIONS_SUCCESS`,
  FETCH_MY_SUBMISSIONS_FAILURE: `${actionTypePrefix}FETCH_MY_SUBMISSIONS_FAILURE`,

  FETCH_SUBMISSION_BY_SUBMISSION_ID: `${actionTypePrefix}FETCH_SUBMISSION_BY_SUBMISSION_ID`,
  FETCH_SUBMISSION_BY_SUBMISSION_ID_SUCCESS: `${actionTypePrefix}FETCH_SUBMISSION_BY_SUBMISSION_ID_SUCCESS`,
  FETCH_SUBMISSION_BY_SUBMISSION_ID_FAILURE: `${actionTypePrefix}FETCH_SUBMISSION_BY_SUBMISSION_ID_FAILURE`,

  CHECK_DUPLICATE_VALUE: `${actionTypePrefix}CHECK_DUPLICATE_VALUE`,
  CHECK_DUPLICATE_VALUE_SUCCESS: `${actionTypePrefix}CHECK_DUPLICATE_VALUE_SUCCESS`,
  CHECK_DUPLICATE_VALUE_ERROR: `${actionTypePrefix}CHECK_DUPLICATE_VALUE_ERROR`,
  RESET_COMPOSITEKEY_DUPLICATE_RESPONSE: `${actionTypePrefix}RESET_COMPOSITEKEY_DUPLICATE_RESPONSE`,

  SET_FORMBUILDER_AS_COMPONENT: `${actionTypePrefix}SET_FORMBUILDER_AS_COMPONENT`,

  UPDATE_SUBMISSION_RESPONDED_DATA: `${actionTypePrefix}UPDATE_SUBMISSION_RESPONDED_DATA`,
  SET_SUBMISSION_DATA_OF_FORM: `${actionTypePrefix}SET_SUBMISSION_DATA_OF_FORM`,

  SET_SUBMISSION_TYPE: `${actionTypePrefix}SET_SUBMISSION_TYPE`,
  OPENED_DATE: `${actionTypePrefix}OPENED_DATE`,
  FORM_OPENED_SUCCESS: `${actionTypePrefix}FORM_OPENED_SUCCESS`,
  FORM_OPENED_FAILURE: `${actionTypePrefix}FORM_OPENED_FAILURE`,
  FORM_OPENED_REQUEST: `${actionTypePrefix}FORM_OPENED_REQUEST`,

  ADD_LINKEDFIELDS_LOOKUP: `${actionTypePrefix}ADD_LINKEDFIELDS_LOOKUP`,
  ADD_LINKEDFIELDS_VALUES: `${actionTypePrefix}ADD_LINKEDFIELDS_VALUES`,
  RESET_LINKEDFIELDS_VALUES: `${actionTypePrefix}RESET_LINKEDFIELDS_VALUES`,
  ADD_MAPPED_VALUES: `${actionTypePrefix}ADD_MAPPED_VALUES`,
  UPDATE_DATAGRID_TABLE_VALUE: `${actionTypePrefix}UPDATE_DATAGRID_TABLE_VALUE`
};

export const updateDataGridTableValue = (fieldId: string, tableValue: ITableSubmissionMap) => {
  return {
    type: formSubmissionActions.UPDATE_DATAGRID_TABLE_VALUE,
    payload: {
      fieldId,
      tableValue,
    },
  };
};
export const setOpenedDatetoRedux = (openedDate: number) => {
  return {
    type: formSubmissionActions.OPENED_DATE,
    payload: openedDate,
  };
};
export const addLinkedFields = (addLinkedFieldPayload: ILinkedFieldPayload) => {
  return {
    type: formSubmissionActions.ADD_LINKEDFIELDS_LOOKUP,
    payload: addLinkedFieldPayload,
  };
};
export const addLinkedFieldsValues = (linkedFieldOptions: ILinkedFieldOptions) => {
  return {
    type: formSubmissionActions.ADD_LINKEDFIELDS_VALUES,
    payload: linkedFieldOptions,
  };
};

export const addMappedLookupValues = (mappedLookupOptions: ILookupOptionsState) => {
  return {
    type: formSubmissionActions.ADD_MAPPED_VALUES,
    payload: mappedLookupOptions,

  };
};


export const resetLinkedFieldsValues = (linkedFieldOptions?: ILinkedFieldOptions) => {
  return {
    type: formSubmissionActions.RESET_LINKEDFIELDS_VALUES,
    payload: linkedFieldOptions ?? [],
  };
};
export const formOpenedRequest = (payload) => ({
  type: formSubmissionActions.FORM_OPENED_REQUEST,
  payload,
});

export const formOpenedSuccess = (response: any) => ({
  type: formSubmissionActions.FORM_OPENED_SUCCESS,
  payload: response,
});

export const formOpenedFailure = (error: any) => ({
  type: formSubmissionActions.FORM_OPENED_FAILURE,
  payload: error,
});

export const addDataGridSubmissionField = (
  fieldId: string,
  submissionId: string,
  actionType: string
) => {
  return {
    type: formSubmissionActions.ADD_DATAGRID_SUBMISSION_ACTIONS,
    payload: {
      fieldId,
      submissionId,
      actionType,
    },
  };
};
export const addDataGridCompositeKeysSetup = (
  fieldId: string,
  actionType: string
) => {
  return {
    type: formSubmissionActions.ADD_DATAGRID_COMPOSITE_KEYS_VALIDATION,
    payload: {
      fieldId,
      actionType,
    },
  };
};
export const setIsSamePage = (actionType: boolean) => {
  return {
    type: formSubmissionActions.SET_IS_SAME_PAGE,
    payload: {
      actionType,
    },
  };
};

export const addVisitedPage = (pageId: string) => {
  return {
    type: formSubmissionActions.ADD_VISITED_PAGE,
    payload: {
      pageId,
    },
  };
};

export const resetVisitedPages = () => {
  return {
    type: formSubmissionActions.RESET_VISITED_PAGES,
    payload: {},
  };
};

export const addNewSubmissionField = (
  fieldInitialization: IFormFieldSubmission,
  index?: number
) => {
  return {
    type: formSubmissionActions.ADD_NEW_FIELD,
    payload: {
      index,
      fieldInitialization,
    },
  };
};
export const setSubmisisonType = (isDraft: boolean) => {
  return {
    type: formSubmissionActions.SET_SUBMISSION_TYPE,
    payload: isDraft,
  };
};
export const updateSubmissionData = (
  fieldData: IFormFieldSubmission,
  index?: number
) => {
  return {
    type: formSubmissionActions.UPDATE_FIELD_DATA,
    payload: {
      index,
      data: fieldData,
    },
  };
};

export const updateSubmissionDataSuccess = (
  fieldData: IFormFieldSubmission,
  index?: number
) => {
  return {
    type: formSubmissionActions.UPDATE_FIELD_DATA_SUCCESS,
    payload: {
      index,
      data: fieldData,
    },
  };
};

export const bulkUpdateSubmissionValues = (
  fieldIds: string[],
  fieldsMap: IFormFieldSubmission[]
) => {
  return {
    type: formSubmissionActions.BULK_UPDATE_FORM_DATA,
    payload: {
      fieldIds,
      data: fieldsMap,
    },
  };
};

export const bulkUpdateSubmissionValuesSuccess = (
  fieldIds: string[],
  fieldsMap: IFormFieldSubmission[]
) => {
  return {
    type: formSubmissionActions.BULK_UPDATE_FORM_DATA_SUCCESS,
    payload: {
      fieldIds,
      data: fieldsMap,
    },
  };
};

export const bulkUpdateSubmissionValuesForValidation = (
  fieldIds: string[],
  fieldsMap: IFormFieldSubmission[]
) => {
  return {
    type: formSubmissionActions.BULK_UPDATE_FORM_DATA_FOR_VALIDATION,
    payload: {
      fieldIds,
      data: fieldsMap,
    },
  };
};
export const setUniversalStorageUnitAction = (
  payload: IUniversalStorageData
) => {
  return {
    type: formSubmissionActions.SET_UNIVERSAL_STORAGE_UNIT,
    payload,
  };
};

export const setIsFormBuilderAsComponentACtion = (payload: boolean) => {
  return {
    type: formSubmissionActions.SET_FORMBUILDER_AS_COMPONENT,
    payload,
  };
};

export const resetSubmissionForm = () => {
  return {
    type: formSubmissionActions.RESET_SUBMISSION_FORM,
    payload: {},
  };
};

export const resetActiveFormSubmission = () => {
  return {
    type: formSubmissionActions.RESET_ACTIVE_FORM_SUBMISSION,
  };
};

export const setActiveFormSubmission = (activeFormSubmissionId: string) => {
  return {
    type: formSubmissionActions.SET_ACTIVE_FORM_SUBMISSION,
    payload: {
      activeFormSubmissionId: activeFormSubmissionId,
    },
  };
};

export const setActiveFormSubmissionSucces = (
  activeFormSubmissionId: string
) => {
  return {
    type: formSubmissionActions.SET_ACTIVE_FORM_SUBMISSION_SUCCESS,
    payload: {
      activeFormSubmissionId: activeFormSubmissionId,
    },
  };
};

export const addFormSubmission = (payload: IAddFormSubmissionPayload) => {
  return {
    type: formSubmissionActions.ADD_FORM_SUBMISSION,
    payload,
  };
};

export const sendOrValidateOTP = (payload: IOtpRequest) => {
  return {
    type: formSubmissionActions.SEND_OR_VALIDATE_OTP,
    payload,
  };
};

export const addFormSubmissionSuccess = (
  formSubmissionData: IFormSubmission
) => {
  return {
    type: formSubmissionActions.ADD_FORM_SUBMISSION_SUCCESS,
    payload: {
      formSubmissionData,
    },
  };
};
export const sendOrValidateOTPSuccess = (
  payload: IOtpRequest
) => {
  return {
    type: formSubmissionActions.SEND_OR_VALIDATE_OTP_SUCCESS,
    payload,
  };
};

export const addFormSubmissionError = (error: string) => {
  return {
    type: formSubmissionActions.ADD_FORM_SUBMISSION_ERROR,
    payload: {
      error,
    },
  };
};
export const sendOrValidateOTPError = (error: string) => {
  return {
    type: formSubmissionActions.SEND_OR_VALIDATE_OTP_ERROR,
    payload: {
      error,
    },
  };
};

export const addFormBulkSubmission = (
  payload: IAddFormBulkSubmissionPayload
) => {
  return {
    type: formSubmissionActions.ADD_FORM_BULK_SUBMISSION,
    payload,
  };
};

export const addFormBulkSubmissionSuccess = (
  formSubmissionData: IFormSubmission
) => {
  return {
    type: formSubmissionActions.ADD_FORM_BULK_SUBMISSION_SUCCESS,
    payload: {
      formSubmissionData,
    },
  };
};

export const addFormBulkSubmissionError = (error: string) => {
  return {
    type: formSubmissionActions.ADD_FORM_BULK_SUBMISSION_ERROR,
    payload: {
      error,
    },
  };
};
export const updateFormBulkSubmission = (
  payload: IAddFormBulkSubmissionPayload
) => {
  return {
    type: formSubmissionActions.UPDATE_FORM_BULK_SUBMISSION,
    payload,
  };
};

export const updateFormBulkSubmissionSuccess = (
  formSubmissionData: IFormSubmission
) => {
  return {
    type: formSubmissionActions.UPDATE_FORM_BULK_SUBMISSION_SUCCESS,
    payload: {
      formSubmissionData,
    },
  };
};

export const updateFormBulkSubmissionError = (error: string) => {
  return {
    type: formSubmissionActions.UPDATE_FORM_BULK_SUBMISSION_ERROR,
    payload: {
      error,
    },
  };
};
export const fetchPincodeData = (
  payload: IFetchPicodePayload
): IFetchPinCode => {
  return {
    type: formSubmissionActions.FETCH_PINCODE_DATA,
    payload,
  };
};

export const fetchFormSubmissions = (
  payload: IFetchFormSubmissionsPayload
): IFetchFormSubmissionsAction => {
  return {
    type: formSubmissionActions.FETCH_FORM_SUBMISSIONS,
    payload,
  };
};

export const fetchFormSubmissionsSuccess = (
  fetchedSubmissions: IFetchFormSubmissionsSuccessPayload
) => {
  return {
    type: formSubmissionActions.FETCH_FORM_SUBMISSIONS_SUCCESS,
    payload: fetchedSubmissions,
  };
};

export const fetchFormSubmissionsError = (error: string) => {
  return {
    type: formSubmissionActions.FETCH_FORM_SUBMISSIONS_ERROR,
    payload: {
      error,
    },
  };
};

export const deleteFormSubmission = (formId: string, index: number) => {
  return {
    type: formSubmissionActions.DELETE_FORM_SUBMISSION,
    payload: {
      formId,
      index,
    },
  };
};

export const deleteFormSubmissionSuccess = (formId: string, index: number) => {
  return {
    type: formSubmissionActions.DELETE_FORM_SUBMISSION_SUCCESS,
    payload: {
      formId,
      index,
    },
  };
};

export const deleteFormSubmissionError = (error: string) => {
  return {
    type: formSubmissionActions.DELETE_FORM_SUBMISSION_ERROR,
    payload: {
      error,
    },
  };
};
export const deleteDatagridFormSubmission = (submissionId: string) => {
  return {
    type: formSubmissionActions.DELETE_DATAGRID_FORM_SUBMISSION,
    payload: {
      submissionId,
    },
  };
};

export const deleteDatagridFormSubmissionSuccess = (
  submissionId: string,
  index: number
) => {
  return {
    type: formSubmissionActions.DELETE_DATAGRID_SUBMISSION_SUCCESS,
    payload: {
      submissionId,
      index,
    },
  };
};

export const deleteDatagridFormSubmissionError = (error: string) => {
  return {
    type: formSubmissionActions.DELETE_DATAGRID_SUBMISSION_ERROR,
    payload: {
      error,
    },
  };
};

export const updateFormSubmission = (formId: string) => {
  return {
    type: formSubmissionActions.UPDATE_FORM_SUBMISSION,
    payload: {
      formId,
    },
  };
};

export const updateFormSubmissionSuccess = (dbFormattedSubmissionData) => {
  return {
    type: formSubmissionActions.UPDATE_FORM_SUBMISSION_SUCCESS,
    payload: {
      dbFormattedSubmissionData,
    },
  };
};

export const updateFormSubmissionError = (error: string) => {
  return {
    type: formSubmissionActions.UPDATE_FORM_SUBMISSION_ERROR,
    payload: {
      error,
    },
  };
};

export const fetchExistingFormSubmissionData = (
  existingFormSubmissionId: string
) => {
  return {
    type: formSubmissionActions.FETCH_EXISTING_FORM_SUBMISSION_DATA,
    payload: {
      existingFormSubmissionId,
    },
  };
};

export const fetchFormSubmissionsDataToExportAction = (
  payload: IFetchFormSubmissionsDataToExportPayload
): IFetchFormSubmissionsDataToExportAction => {
  return {
    type: formSubmissionActions.FORM_SUBMISSIONS_EXPORT,
    payload,
  };
};

export const fetchMySubmissions = (payload: IFetchMySubmissionsPayload) => {
  return {
    type: formSubmissionActions.FETCH_MY_SUBMISSIONS,
    payload,
  };
};

export const fetchMySubmissionsSuccess = (
  mySubmissionPaginationData: IFormSubmissionPagination,
  mySubmissionsMap: IFieldSubmissionMap[],
  mySubmissionIds: string[]
) => {
  return {
    type: formSubmissionActions.FETCH_MY_SUBMISSIONS_SUCCESS,
    payload: {
      mySubmissionPaginationData,
      mySubmissionsMap,
      mySubmissionIds,
    },
  };
};

export const fetchMySubmissionsFailure = (error: string) => {
  return {
    type: formSubmissionActions.FETCH_MY_SUBMISSIONS_FAILURE,
    payload: {
      error,
    },
  };
};

export const fetchSubmissionBySubmissionId = (
  submissionId: string,
   roleName?:string 
): IFetchSubmissionBySubmissionId => {
  return {
    type: formSubmissionActions.FETCH_SUBMISSION_BY_SUBMISSION_ID,
    payload: {
      submissionId,
        roleName
    },
  };
};

export const fetchSubmissionBySubmissionIdSuccess = (
  submissionMap: IFieldSubmissionMap
) => {
  return {
    type: formSubmissionActions.FETCH_SUBMISSION_BY_SUBMISSION_ID_SUCCESS,
    payload: {
      submissionMap,
    },
  };
};

export const fetchSubmissionBySubmissionIdFailure = (error: string) => {
  return {
    type: formSubmissionActions.FETCH_SUBMISSION_BY_SUBMISSION_ID_FAILURE,
    payload: {
      error,
    },
  };
};

export const fetchFormSubmissionSettingsAction = (
  formId: string
): IFetchFormSubmissionSettingsAction => {
  return {
    type: formSubmissionActions.FETCH_FORM_SUBMISSION_SETTINGS,
    payload: {
      formId,
    },
  };
};

export const fetchFormSubmissionSettingsSuccessAction = (
  payload: IFetchFormSubmissionSettingsSuccessActionPayload
) => {
  return {
    type: formSubmissionActions.FETCH_FORM_SUBMISSION_SETTINGS_SUCCESS,
    payload,
  };
};

export const fetchFormSubmissionSettingsFailureAction = (
  payload: IFetchFormSubmissionSettingsFailureActionPayload
) => {
  return {
    type: formSubmissionActions.FETCH_FORM_SUBMISSION_SETTINGS_FAILURE,
    payload,
  };
};

export const checkDuplicateSubmissionAction = (
  formId: string,
  submissionId?: string
) => {
  return {
    type: formSubmissionActions.CHECK_DUPLICATE_VALUE,
    payload: {
      formId,
      submissionId,
    },
  };
};

export const checkDuplicateSubmissionSuccess = (
  payload: ICheckDuplicateSubmissionFieldSuccessResponsePayload
) => {
  return {
    type: formSubmissionActions.CHECK_DUPLICATE_VALUE_SUCCESS,
    payload,
  };
};

export const resetCompositeKeyDuplicateResponse = () => {
  return {
    type: formSubmissionActions.RESET_COMPOSITEKEY_DUPLICATE_RESPONSE,
  };
};

export const checkDuplicateSubmissionError = (error: string) => {
  return {
    type: formSubmissionActions.CHECK_DUPLICATE_VALUE_ERROR,
    payload: {
      error,
    },
  };
};

export const respondedSubmissionData = (
  respondedData: IRespondedBySubmissionMap
) => {
  return {
    type: formSubmissionActions.UPDATE_SUBMISSION_RESPONDED_DATA,
    payload: respondedData,
  };
};

export const setSubmissionDataOfForm = (response: any) => {
  return {
    type: formSubmissionActions.SET_SUBMISSION_DATA_OF_FORM,
    payload: response,
  };
};
